import { actionTypes } from 'actions/actionTypes'
import { promoApply, promoChange } from 'actions/promos'
import { redirect } from 'actions/redirect'
import { clickGetStarted } from 'actions/trackingKeys'
import { BLACK_FRIDAY_DISCOUNT, PROMO_CODE_DATA } from 'routes/Home/homeConfig'
import { getPromoBannerState } from 'routes/Home/homeUtils'
import { ThunkActionCreator } from 'routes/Home/types/ThunkActionCreator'
import { getUTMAndPromoCode } from 'selectors/tracking'
import logger from 'utils/logger'

export const applyPromoCodeAndShowModal: ThunkActionCreator = () => async (dispatch, getState) => {
  const state = getState()
  const { canApplyPromo } = getPromoBannerState(state)
  if (!canApplyPromo) {
    return
  }

  // @todo [B20-72] to revert after Black Friday promotion ends
  const isBlackFridayPromotionEnabled = true

  let promoCode = PROMO_CODE_DATA.defaultPromoCode
  if (isBlackFridayPromotionEnabled) {
    promoCode = BLACK_FRIDAY_DISCOUNT.defaultPromoCode
  }

  try {
    await dispatch(promoChange(promoCode))
    await dispatch(promoApply())
  } catch (err) {
    logger.warning(`error fetching promo code ${promoCode} - ${(err as Error).message}`)
  }
}

export const trackGetStarted: ThunkActionCreator =
  (trackingSectionName: string) =>
  (dispatch, getState, { experiments }) => {
    const { promoCode, UTM } = getUTMAndPromoCode(getState())
    experiments.track('start_onboarding')
    dispatch({
      type: actionTypes.TRACKING,
      trackingData: {
        actionType: clickGetStarted,
        section: trackingSectionName,
        ...UTM,
        promoCode,
      },
    })
  }

export const homeGetStarted: ThunkActionCreator =
  (ctaUri: string, sectionForTracking?: string) => async (dispatch) => {
    if (sectionForTracking) {
      dispatch(trackGetStarted(sectionForTracking))
    }

    await dispatch(applyPromoCodeAndShowModal())

    dispatch(redirect(ctaUri))
  }
